module.exports = __webpack_public_path__ + "img/example-card-3.3df80730.png";